import { index,  getLastNumber, getSelectedNumber, show, store, update, destroy, inventory, showItem, defect, allDefect, allData} from '../../../api/dailyTreatment';

export const actions = {

    index({commit}, params = {}) {
        return new Promise((resolve, reject) => {
            index(params).then(res => {
                commit("SET_LIST", res.data.data.dailyTreatments.data);
                commit("SET_DATE_LIST", res.data.data.dates);
                commit("UPDATE_PAGINATION",{key: 'total', value: res.data.data.dailyTreatments.pagination.total});
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    // allData({commit}, params = {}) {
    //     return new Promise((resolve, reject) => {
    //         allData(params).then(res => {
    //             commit("SET_LIST", res.data.data.dailyTreatments.data);
    //             commit("patientIndicators/SET_LIST", res.data.data.patientIndicators.data);
    //             commit("SET_DEFECT", res.data.data.defect.data);
    //             commit("SET_DATE_LIST", res.data.data.dates);
    //             commit("UPDATE_PAGINATION",{key: 'total', value: res.data.data.dailyTreatments.pagination.total});
    //             resolve(res.data)
    //         }).catch(err => {
    //             console.log(err);
    //             reject(err.response.data)
    //         })
    //     })
    // },

    inventory({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
          inventory(params)
            .then(response => {
              commit('SET_INVENTORY', response.data.data.dailyTreatments.data);
              resolve(response.data);
            })
            .catch(error => {
              reject(error.response.data);
            });
        });
    },    
    show({commit},params = {}) {
        return new Promise((resolve,reject) => {
            show(params).then(res => {
                commit("SET_LIST",res.data.data.dailyTreatment.data);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    getLastNumber({commit},params = {}) {
        return new Promise((resolve,reject) => {
            getLastNumber(params).then(res => {
                commit("SET_LAST_NUMBER",res.data.data.patientHistory);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    getSelectedNumber({commit},params = {}) {
        return new Promise((resolve,reject) => {
            getSelectedNumber(params).then(res => {
                commit("SET_LAST_NUMBER",res.data.data.patientHistory);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    showItem({commit},id) {
        return new Promise((resolve,reject) => {
            showItem(id).then(res => {
                commit("SET_MODEL",res.data.data.dailyTreatment);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    store({commit},data) {
        return new Promise((resolve,reject) => {
            store(data).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    update({commit},data) {
        return new Promise((resolve,reject) => {
            update(data).then(res => {
                commit("SET_MODEL",res.data.data.dailyTreatment);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    destroy({commit},id) {
        return new Promise((resolve,reject) => {
            destroy(id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },
    defect({commit},params = {}) {
        return new Promise((resolve,reject) => {
            defect(params).then(res => {
                commit("SET_DEFECT", res.data.data.defect.data);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    allDefect({commit},params = {}) {
        return new Promise((resolve,reject) => {
            allDefect(params).then(res => {
                commit("SET_ALL_DEFECT", res.data.data.allDefect.data);
                resolve(res.data)
            }).catch(err => {
                reject(err.response.data)
            })
        })
    },

    updateSort({commit}, sort){
        commit("SET_SORT",sort)
    },

    updateFilter({commit}, filter){
        commit('SET_FILTER', JSON.parse( JSON.stringify( filter)))
    },

    updateColumn({commit}, obj){
        commit('UPDATE_COLUMN', obj)
    },

    updatePagination({commit}, pagination){
        commit('UPDATE_PAGINATION', pagination )
    },

    refreshData({commit}){
        return new Promise((resolve, reject) => {
            commit("REFRESH");
            resolve()
        })
    },
    empty({ commit }) {
        return new Promise((resolve, reject) => {
            commit("EMPTY_MODEL");
            resolve()
        })
    },


}
